module.exports = __webpack_public_path__ + "img/modalcover.d5cb4b04.png";